import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Location } from '@angular/common';
import { Http, Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';

import { UserService } from './user.service';
import { environment } from '../../../../environments/environment';
import { UbiFilterService } from '../../../theme';
import { ApiService, MetadataService } from '../../../ubi-core/ubi-core.module';
import { DynamicGridComponent } from '../../../dynamic-entity/components/dynamic-grid/dynamic-grid.component';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';

const API_URL = environment.apiUrl;

@Component({
  selector: 'app-template',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent extends DynamicGridComponent {

  private mappingForm: FormGroup;
  public mainForm: FormGroup;

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService) {

    super(baseservice, metadataservice, router, route, modalService, filterservice);
  }


  /**
   * Get data on onInit
   *
   * This is an override
   */
  protected getInitialData() {

    this.baseservice.setEntity(this.entity + '/GetUsers');
    this.getPage({ offset: 0 }, this.filter);
  }

  /**
   * Open detail view of selected record
   *
   */
  public openDetail({ selected }) {
    if (this.navigateUrl !== null && this.navigateUrl !== undefined) {
      this.router.navigateByUrl(this.navigateUrl + '/' + selected[0].id);
    }
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/config/users/users.component.ts